<template>
	<div class="">
		<div style=" display: flex; justify-content: space-between; align-items: flex-end;font-weight: 600; margin-bottom: 25px;">
			<div style="font-size: 24px;  border-left: 5px solid #333;color: #333;padding-left: 12px;">
				<span v-if="menu_id == 14 ">推荐阅读</span>
			</div>
			<div style="position: absolute; right: 35px; display: flex; align-items: center; cursor: pointer;" @click="pptHide" v-if="pptShow">
				<i class="iconfont icon-back" style="margin-right: 5px; margin-bottom: -3px;font-size: 32px;"></i>
				<div style="font-size: 22px;">返回</div>
			</div>
		</div>
		<div class="teach_design-items" v-if="!pptShow">
			<div class="teach_design-item" v-for="(item,index) of chapterList" @click="linkOpenClick(item)">
				<div class="teach_design-icon">
					<i class="iconfont icon-weixintuwenxiaoxi" v-if="item.res_type == 5"></i>
					<i class="iconfont icon-pdf" v-if="item.res_type == 6"></i>
				</div>
				<div class="teach_design-title" style="">{{item.title}}</div>
				<div class="triangle_white"></div>
				<div class="triangle_black"></div>
			</div>
		</div>
		<div style="width: 100%;display: flex;flex-direction: column; position: relative;" v-if="pptShow">
			<div class="" style=" width: 100%; height: 449px; border: 0 solid #fff; background-color: #fff; box-sizing: border-box; position: relative; ">
				<div v-if="selected && selected.res_type ==6 && selected.res_url" style="display:flex; width: 100%; height: 449px; z-index: 2; justify-content: center; align-items: center;">
					<iframe :src="selected.res_url" scrolling="auto" frameborder="0" width="100%" height="100%" align="center"></iframe>
					<div @click="fullscreenClick" style="position: absolute; width: 30px; height: 30px; border-radius: 50%; background-color: #2C2E30; bottom: 30px; right: 30px;display: flex; flex-direction: column;justify-content: center;align-items: center; cursor: pointer;">
						<i class="el-icon-full-screen" style="color: #ccc; font-weight: 600;"></i>
					</div>
				</div>
			</div>
			<div class="" style="width: 100%; height: 50px; background-color: #333;display: flex;">
				<div class="" style="flex: 1; display: flex;align-items: center; color: #fff; padding: 0 20px; box-sizing: border-box;">
					<i class="el-icon-document" style="font-size: 20px;margin-right: 5px;"></i><span v-if="selected && selected.title">{{selected.title}}</span>
				</div>
			</div>
		</div>
		
		<!-- 全屏 -->
		<el-dialog v-if="zoomShow" :visible.sync="zoomShow" destroy-on-close :fullscreen="true">
			<!-- pdf浏览器 -->
			<div class="full-height-body" style=" display: block; width: 100%; height:100%;overflow: hidden; " v-if="selected.res_type ==6 && selected.res_url">
				<iframe :src="selected.res_url" scrolling="auto" frameborder="0" width="100%" height="100%" align="center"></iframe>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	
	export default {
		props:{
			myid: String,
			mymenu: String,
		},
		data() {
			return {
				id: this.myid,
				menu_id: this.mymenu,
				chapterList: [],
				pptShow:false,
				selected:null,
				zoomShow:false,
			};
		},
		created() {
			this.getChapters();
		},
		methods: {
			linkOpenClick(item){
				if(item.res_type ==5){
					window.open(item.res_url, '_blank');
				}else if(item.res_type ==6){
					this.pptShowClick(item);
				}
			},
			getChapters() {
				var that = this;
				var url = apiUrl.tt_digital_office_ext_list_get;
				this.Ajax(url, {
					office_id: this.id,
					menu_id: this.menu_id
				}, (data) => {
					that.chapterList = data;
				});
			},
			pptHide(){
				this.pptShow = false;
			},
			pptShowClick(item){
				this.pptShow = true;
				this.getRes(item);
			},
			getRes(item){
				var that = this;
				var url = apiUrl.digital_office_ext_detail_get;
				this.Ajax(url, {
					id: item.id,
				}, (data) => {
					if(data.res_type == 6){
						that.selected = {
							title: data.title,
							res_url: `/pdf.js/4.7.76/web/viewer.html?file=${ encodeURIComponent(data.res_url) }`,
							res_type: data.res_type,
							id: data.id
						};
					}
				});
			},
			fullscreenClick(){
				var that = this;
				that.$nextTick(() => {
					that.zoomShow = true;
				})
			},
		},
	};
</script>


<style lang="scss" scoped>
	
	
	.teach_design-items {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	
		.teach_design-item {
			display: flex;
			flex-direction: column;
			width: 170px;
			height: 180px;
			padding: 0 25px;
			justify-content: center;
			align-items: center;
			background-color: #E4E4E4;
			color: #999;
			position: relative;
			margin: 0 30px 30px 0;
			cursor: pointer;
	
			&:nth-child(4n) {
				margin-right: 0;
			}
	
			.icon-ppt {
				font-size: 70px;
			}
			.teach_design-icon{
				line-height: 1 !important;
				 
				 .iconfont{
					font-size: 70px !important;
				 }
			}
	
			.teach_design-title {
				font-size: 18px;
				margin-top: 15px;
				text-align: center;
				line-height: 1.2;
			}
	
			.triangle_white {
				position: absolute;
				width: 0;
				right: 0;
				bottom: 0;
				border-top: 13px solid transparent;
				border-right: 13px solid #eee;
				border-bottom: 13px solid #eee;
				border-left: 13px solid transparent;
			}
	
			.triangle_black {
				position: absolute;
				width: 0;
				right: 0;
				bottom: 0;
				border-top: 10px solid transparent;
				border-right: 10px solid #999;
				border-bottom: 10px solid #999;
				border-left: 10px solid transparent;
			}
	
			&:hover,&.actived {
				//background: linear-gradient(to bottom right, #B6DED5, #36DEC1);
				background: #fff;
				color: #CA6927;
				box-shadow: 3px 5px 3px rgba(0, 0, 0, 0.3);
	
				.teach_design-title {
					color: #333;
				}
	
				.triangle_black {
					border-right: 10px solid #CA6927;
					border-bottom: 10px solid #CA6927;
				}
			}
		}
	}
</style>